import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { projectInviteUrl } from '@views/login/project-invite/project-invite.path';
import { AuthService } from '@views/misc/auth/auth.service';

/**
 * Variant of `LoggedInGuard` for the account setup screen. An authenticated user has no password to
 * set, so they're sent away — but when their link carries a construction-project invitation they go
 * to the route that redeems it rather than to the dashboard, which would drop the token. (That route
 * is itself gated on the projects feature, so with the feature off this redirect falls through to the
 * dashboard anyway.)
 */
export const initialLoginGuard: CanActivateFn = route => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.checkIsLoggedIn()) {
    return true;
  }

  const token = route.queryParamMap.get('token');
  const userId = route.queryParamMap.get('userId') ?? '';

  return token ? router.parseUrl(projectInviteUrl(userId, token)) : router.createUrlTree(['/']);
};
